function getUserConfig(campo){

    var _cfg = localStorage.getItem('_ssat');

    if (_cfg != null) {
        _cfg = JSON.parse(_cfg);

        return _cfg[campo];
    }

    return '0';

}

module.exports = { getUserConfig }